import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getPromotions, savePromotion, setPromotionDeleted, promotionError } from "../api/promotions";

export default function usePromotions(kind) {
  const token = useSelector((state) => state.user.token);
  const [query, setQuery] = useState({ page: 1, limit: 50, search: "", enabled: "", deleted: "" });
  const [result, setResult] = useState({ rows: [], total: 0, headers: [] });
  const [placements, setPlacements] = useState([]), [placementsError, setPlacementsError] = useState("");
  const [placementsLoading, setPlacementsLoading] = useState(true);
  const [loading, setLoading] = useState(true), [error, setError] = useState(""), [attempt, setAttempt] = useState(0);
  const [saving, setSaving] = useState(false);
  const [actionError, setActionError] = useState("");
  const writing = useRef(false);
  useEffect(() => {
    const controller = new AbortController(); setLoading(true); setError(""); setActionError("");
    getPromotions(token, kind, query, controller.signal).then((value) => {
      if (controller.signal.aborted) return;
      if (kind === "placements") {
        value.rows = value.rows.filter((item) => (!query.search || `${item.code} ${item.title}`.includes(query.search))
          && (!query.enabled || String(item.enabled) === query.enabled));
        value.total = value.rows.length;
        value.rows = value.rows.slice((query.page - 1) * query.limit, query.page * query.limit);
      }
      const last = Math.max(1, Math.ceil(value.total / query.limit));
      if (query.page > last) setQuery((current) => ({ ...current, page: last }));
      else setResult(value);
    }).catch((reason) => { if (!controller.signal.aborted) { setError(promotionError(reason)); setResult({ rows: [], total: 0, headers: [] }); } })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [token, kind, query, attempt]);
  useEffect(() => {
    const controller = new AbortController(); setPlacementsError(""); setPlacements([]); setPlacementsLoading(true);
    getPromotions(token, "placements", { page: 1, limit: 100 }, controller.signal)
      .then((value) => { if (!controller.signal.aborted) setPlacements(value.rows); })
      .catch((reason) => { if (!controller.signal.aborted) setPlacementsError(promotionError(reason)); })
      .finally(() => { if (!controller.signal.aborted) setPlacementsLoading(false); });
    return () => controller.abort();
  }, [token, attempt]);
  async function save(original, payload) {
    if (writing.current) return false;
    writing.current = true; setSaving(true);
    try { await savePromotion(token, kind, original, payload); setAttempt((value) => value + 1); return true; }
    catch (reason) { throw new Error(promotionError(reason)); }
    finally { writing.current = false; setSaving(false); }
  }
  async function changeDeleted(original, deleted) {
    if (writing.current) return false;
    writing.current = true; setSaving(true); setActionError("");
    try { await setPromotionDeleted(token, original, deleted); setAttempt((value) => value + 1); return true; }
    catch (reason) { const message = promotionError(reason); setActionError(message); throw new Error(message); }
    finally { writing.current = false; setSaving(false); }
  }
  return { ...result, query, loading, error, actionError, saving, placements, placementsError, placementsLoading, save,
    remove: (original) => changeDeleted(original, true), restore: (original) => changeDeleted(original, false),
    apply: (next) => setQuery({ ...next, page: 1 }),
    page: (page) => setQuery((current) => ({ ...current, page })),
    reload: () => setAttempt((value) => value + 1) };
}
